<template>
    <div class="servicios">
        <div class="title">
            <span>Seguros</span>
            <h1>Personales y Familia</h1>
            <p>Cuidando tu bienestar y trascendencia</p>
        </div>
        <div class="services">
            <center>
                <h1>Conoce nuestras soluciones</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <p>{{slide.title}}</p>
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service">
                            <div>
                                <div>
                                    <h5 v-html="service.text"></h5>
                                    <button @click="$router.push('/servicios/personas/' + service.route)">VER MÁS</button>
                                </div>
                                <img :src="service.img" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="connect">
            <center>
                    <img src="@/assets/bg-llamado-accion.webp" alt="">
                    <h5>La seguridad de tu empresa y la de tus trabajadores, <br> es lo más imporntante para nosotros</h5>
                    <button @click="$router.push('/connect')">Iniciar hoy mismo</button>
            </center>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Servicios',
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    metaInfo() {
        return {
            title: 'Seguros Personales y Familia.',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para personas como viajes, educación, títulos de capitalización, entre otros.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para personas como viajes, educación, títulos de capitalización, entre otros.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    data() {
        return {
            slides: [
                {
                    title: 'Vida y Protección',
                    service: [
                        {
                            text: 'Seguro de Educación',
                            img: require('@/assets/Personas/1.png'),
                            route: 'seguro-educación'
                        },
                        {
                            text: 'Seguro de Vida',
                            img: require('@/assets/Personas/2.png'),
                            route: 'seguro-vida'
                        },
                        {
                            text: 'Seguro de Mascotas',
                            img: require('@/assets/Personas/3.png'),
                            route: 'seguro-mascotas'
                        }
                    ]
                },
                {
                    service: [
                        {
                            text: 'Seguros de Accidentes Personales',
                            img: require('@/assets/Personas/4.png'),
                            route: 'seguro-accidentes-personales'
                        },
                        {
                            text: 'Seguros Exequiales',
                            img: require('@/assets/Personas/5.png'),
                            route: 'seguro-exequiales'
                        }
                    ]
                },
                {
                    title: 'Salud y Bienestar',
                    service: [
                        {
                            text: 'Seguro de Salud',
                            img: require('@/assets/Personas/6.png'),
                            route: 'seguro-salud'
                        },
                        {
                            text: 'Movilidad',
                            img: require('@/assets/Personas/7.png'),
                            route: 'seguro-soat-movilidad'
                        },
                        {
                            text: 'Seguro de Motos',
                            img: require('@/assets/Personas/13.png'),
                            route: 'seguro-motos'
                        }
                    ]
                },
                {
                    service: [
                        {
                            text: 'Seguro de Autos',
                            img: require('@/assets/Personas/14.png'),
                            route: 'seguro-autos'
                        }
                    ]
                },
                {
                    title: 'Inversión y Ahorro',
                    service: [
                        {
                            text: 'Seguro de Pensión',
                            img: require('@/assets/Personas/8.png'),
                            route: 'seguro-pension'
                        },
                        {
                            text: 'Plan Inversión Protegida',
                            img: require('@/assets/Personas/9.png'),
                            route: 'plan-inversion'
                        },
                        {
                            text: 'Fondo de Ahorro',
                            img: require('@/assets/Personas/10.png'),
                            route: 'fondo-ahorro'
                        }
                    ]
                },
                {
                    title: 'Hogar',
                    service: [
                        {
                            text: 'Seguro de Hogar',
                            img: require('@/assets/Personas/11.png'),
                            route: 'seguro-hogar'
                        },
                        {
                            text: 'Seguro de Arrendamiento',
                            img: require('@/assets/Personas/12.png'),
                            route: 'seguro-arrendamiento'
                        }
                    ]
                }
            ]
        }
    }
}
</script>

<style>

</style>

<style scoped>
    .title {
        background-image: url('../../assets/servicios-bg-personas.png');
        padding: 100px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }

    .title > span {
        font-family: 'JLI';
        font-size: 32px;
    }

    .title > h1 {
        font-family: 'JBD';
    }

    .title > p {
        font-family: 'JR';
        font-size: 26px
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
    }
    .services > center > div > p {
        text-align: left;
        color: #65b24a;
        font-family: 'JBD';
        margin-left: 25px;
        font-size: 25px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service {
        width: 100%;
    }
    .services > center > div > div > .service > div {
        position: relative;
        width: 95%;
        height: 100%;
        padding: auto;
        margin-bottom: 35px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service > div > div {
        position: absolute;
        color: #fff;
        padding-top: 120px;
        padding-left: 25px;
        height: auto;
    }
    .services > center > div > div > .service > div > div > h5 {
        font-family: 'JBD';
        color: #fff;
        text-align: left;
    }
    .services > center > div > div > .service > div > div > button {
        font-family: 'JR';
        background-color: #65b24a;
        min-width: 120px;
        width: auto;
        height: auto;
        padding: 0px 30px;
        border-radius: 20px;
        border-color: #65b24a;
        border-style: solid;
        font-size: 12px;
        color: #fff;
        position: absolute;
        left: 25px;
    }
    .services > center > div > div > .service > div > div > button:hover {
        background-color: #2d4f98;
    }

    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }

    .connect > center > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }

    .connect > center h5 {
        font-family: 'JBD';
        position: absolute;
        left: 100px;
        margin-top: 90px;
        font-size: 25px;
        color: #fff;
        text-align: left;
    }

    .connect > center h1 span{
        color: #65b24a;
    }

    .connect > center button {
        font-family: 'JR';
        position: absolute;
        right: 350px;
        margin-top: 90px;
        background-color: #2d4f98;
        color: #fff;
        border-radius: 14px;
        padding: 7px 25px 7px 25px;
        border-style: none;
        font-weight: bolder;
        font-size: 18px;
        border-style: solid;
        border-color: #2d4f98;
    }

    .connect > center button:hover {
        background: rgba(0,0,0,0);
        color: #fff;
        border-color: #fff;
        border-style: solid;
    }

    @media (max-width: 1500px) {
        .services {
            padding: 50px 150px;
        }
        .title {
            padding: 100px 150px;
        }
    }
    @media (max-width: 1400px) {
        .connect > center button {
            right: 250px;
        }
    }
    @media (max-width: 1250px) {
        .services {
            padding: 50px 75px;
        }
        .title {
            padding: 100px 75px;
        }
        .connect > center button {
            right: 150px;
        }
    }
    @media (max-width: 1100px) {
        .services {
            padding: 50px 25px;
        }
        .title {
            padding: 100px 25px;
        }
        .connect > center button {
            right: 75px;
        }
        .connect > center h5 {
            left: 75px;
        }
    }
    @media (max-width: 1000px) {
        .services > center > div > div > .service > div > div {
            padding-top: 90px;
        }
        .connect > center button {
            right: 25px;
        }
        .connect > center h5 {
            left: 25px;
        }
    }
    @media (max-width: 900px) {
        .services > center > div > div > .service > div > div {
            padding-top: 60px;
        }
        .connect > center button {
            margin: 0;
            position: relative;
        }
        .connect > center h5 {
            text-align: center;
            display: block;
            position: sticky;
            z-index: 9999999999;
            padding-top: 50px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div > .service > div > div {
            padding-top: 30px;
        }
    }
    @media (max-width: 700px) {
        .services > center > div > div {
            display: block;
        }
        .services > center > div > div {
            float: none;
        }
        .services > center > div > p {
            text-align: center;
            margin-left: 0px;
        }
        .services > center > div > div {
            width: 60%;
        }
        .services > center > div > div > .service > div > div {
            padding-top: 120px;
        }
        .connect > center h5 {
            font-size: 20px;
        }
    }
    @media (max-width: 600px) {
        .services > center > div > div > .service > div > div {
            padding-top: 90px;
        }
        .services > center > div > div {
            width: 70%;
        }
    }
    @media (max-width: 600px) {
        .services > center > div > div > .service > div > div {
            padding-top: 60px;
        }
        .services > center > div > div {
            width: 80%;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div > .service > div > div {
            padding-top: 30px;
        }
        .connect > center h5 {
            padding-top: 25px;
            font-size: 16px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Servicios/Personas.vue